import React from 'react';

const base = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const ArrowUpIcon = () => (
  <svg {...base}>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>
);
export const PlusIcon = () => (
  <svg {...base}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);
export const ChevronIcon = () => (
  <svg {...base} width={16} height={16}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);
export const ExternalIcon = () => (
  <svg {...base} width={14} height={14}>
    <path d="M7 17L17 7M8 7h9v9" />
  </svg>
);
export const ThumbUpIcon = () => (
  <svg {...base} width={18} height={18}>
    <path d="M7 11v9H4v-9h3zM7 11l4-8c1.5 0 2.5 1 2.5 2.5V9H19a2 2 0 012 2.3l-1.2 7A2 2 0 0117.8 20H7" />
  </svg>
);
export const ThumbDownIcon = () => (
  <svg {...base} width={18} height={18}>
    <path d="M17 13V4h3v9h-3zM17 13l-4 8c-1.5 0-2.5-1-2.5-2.5V15H5a2 2 0 01-2-2.3l1.2-7A2 2 0 016.2 4H17" />
  </svg>
);
export const HomeIcon = () => (
  <svg {...base}>
    <path d="M4 11l8-7 8 7v9h-5v-6H9v6H4z" />
  </svg>
);
export const CopyIcon = () => (
  <svg {...base} width={16} height={16}>
    <path d="M9 9h10v11H9zM5 15V4h10" />
  </svg>
);
export const CheckIcon = () => (
  <svg {...base} width={16} height={16}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);
export const ShareIcon = () => (
  <svg {...base} width={16} height={16}>
    <path d="M12 15V3M7 8l5-5 5 5M5 13v7h14v-7" />
  </svg>
);
export const DownloadIcon = () => (
  <svg {...base} width={16} height={16}>
    <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
  </svg>
);
